<template>
	<el-dialog
		:modal-append-to-body="true"
		:append-to-body="true"
		:title="permissionUser.userName + '权限设置'"
		:visible.sync="dialogVisible"
		@close="handlerCloseDialog"
		:close-on-click-modal="false"
		:destroy-on-close="true"
		@open="handlerOpenDialog">
		<div class="role-auth">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-row :gutter="50">
					<el-col :span="6">
						<div class="authFilter" style="margin-bottom: 20px">
							<el-input
								:placeholder="$t('roleAuth.pAuthFilter')"
								size="small"
								:clearable="true"
								v-model="authFilterText"></el-input>
						</div>
						<el-tree
							:data="menuList"
							ref="authTree"
							accordion
							:expand-on-click-node="true"
							node-key="id"
							:check-strictly="false"
							:filter-node-method="authFilterNode"
							@node-click="menuNodeClick">
							<!-- :show-checkbox="selection" -->
							<!-- @check="menuNodeCheck" -->
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>{{ data.label }}</span>
								<span v-if="data.menuType === 0"
									>（{{ $t("roleAuth.mq") }}）</span
								>
								<span v-if="data.menuType === 1"
									>（{{ $t("roleAuth.mw") }}）</span
								>
								<span v-if="data.menuType === 2"
									>（{{ $t("roleAuth.me") }}）</span
								>
							</span>
						</el-tree>
					</el-col>
					<el-col :span="12">
						<span style="margin-bottom: 15px; display: block">
							<el-button
								type="primary"
								icon="el-icon-folder-checked"
								size="small"
								@click="handlerOpenDialog"
								>{{ $t("roleAuth.reset") }}</el-button
							>
							<el-button
								type="success"
								icon="el-icon-guide"
								size="small"
								:disabled="loadingForm"
								@click="assignAuthority"
								>{{ $t("roleAuth.assign") }}</el-button
							>
						</span>
						<vue-scroll>
							<div class="power" style="max-height: 5.5rem">
								<div
									v-for="item in listPower"
									:key="item.id"
									class="list-power">
									<div class="power-title">
										{{ item.name
										}}<el-button
											@click="handleCheckAllChange(item.id)"
											type="text"
											>{{ $t("roleAuth.check") }}</el-button
										>
									</div>
									<el-checkbox-group
										v-model="power"
										@change="handleCheckedCitiesChange">
										<el-checkbox
											v-for="city in item.children"
											:label="city.id"
											:key="city.id">
											{{ city.name }}
											<!-- {{ city.id }} -->
										</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>
						</vue-scroll>
					</el-col>
				</el-row>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "RoleAuth",
	data() {
		return {
			roleFilterText: "",
			authFilterText: "",
			menuList: [],
			selection: true,
			roleId: "",
			menuId: [],
			roleAuth: {
				userName: "",
				nickName: "",
			},
			listMenu: [],
			listPower: [],
			power: [],
			checked: {},
			loadingForm: false,
			// 权限回显
			authedInfo: {}, //其中checked则为submit数组
			allIds: [],
		};
	},
	props: {
		permissionUser: Object,
		dialogVisible: Boolean,
		roleList: Array,
	},
	watch: {
		authFilterText(val) {
			this.$refs.authTree.filter(val);
		},
	},
	mounted() {},
	methods: {
		// 打开dialog
		async handlerOpenDialog() {
			this.power = [];
			this.allIds = [];
			await this.authedList();
			console.log(this.authedInfo, "权限回显");
			await this.loadMenu();
		},
		// 关闭dialog
		handlerCloseDialog() {
			this.$emit("close");
		},
		// 用户权限数据回显
		async authedList() {
			this.loading = true;
			if (!this.permissionUser.id) {
				this.$message.error(
					"前端错误,无效的userId,id=" + this.permissionUser.id
				);
				return;
			}
			let params = {};
			params.uId = this.permissionUser.id;
			let res = await this.$api.request(
				this.$url.DealerAuthority.authed,
				this.$method.get,
				params
			);
			if (res.code == 0) {
				this.authedInfo = res.data;
				this.listPower = this.authedInfo.menu;
				// 获取全部ids数组
				if (res.data.menu?.length >= 0) {
					res.data.menu.forEach(item => {
						if (!(item.children?.length >= 0)) return;
						item.children.forEach(ite => {
							this.allIds.push(ite.id);
						});
					});
				}
				console.log(222, this.allIds);
				// power当前选中赋值
				this.power = this.getArrDifference(this.allIds, res.data.checked);
			} else {
				this.$message.warning(res.msg);
			}
		},

		async loadMenu() {
			this.loading = true;
			let params = {};
			params.uId = this.permissionUser.id;
			await this.$api
				.request(this.$url.DealerAuthority.load, this.$method.get, params)
				.then(res => {
					if (res.code === 0) {
						this.menuList = res.data;
						this.$refs.authTree.setCheckedKeys(this.authedInfo.roleMenu);
					} else {
						this.$message.warning(res.msg);
					}
				});
		},
		// 来到置顶
		menuNodeClick(e) {
			if (e && !e.children) {
				for (let i = 0; i < this.listPower.length; i++) {
					if (e.id == this.listPower[i].id) {
						console.log("已找到");
						let obj = this.listPower[i];
						this.listPower.splice(i, 1);
						this.listPower.unshift(obj);
						return;
					}
				}
			}
		},
		handleCheckAllChange(val) {
			this.listPower.forEach(key => {
				if (key.id === val) {
					key.children.forEach(m => {
						if (this.power.indexOf(m.id) == -1) {
							this.power.push(m.id);
						}
					});
					return false;
				}
			});
			this.handleCheckedCitiesChange(this.power);
		},
		handleCheckedCitiesChange(value) {
			console.log(value);
		},
		getArrDifference(allArr, delArr) {
			console.log(allArr, delArr);
			return allArr.filter(item => !delArr.includes(item));
		},
		authFilterNode(value, data) {
			if (!value) return true;
			return data.name.indexOf(value) !== -1;
		},
		assignAuthority() {
			let auth = this.$refs.authTree.getCheckedNodes(false, true);
			if (auth && auth.length > 0) {
				this.$confirm(this.$t("roleAuth.isRole"), this.$t("common.tip"), {
					confirmButtonText: this.$t("common.definite"),
					cancelButtonText: this.$t("common.cancel"),
					type: "warning",
				}).then(() => {
					let menuIds = this.getArrDifference(this.allIds, this.power);
					let obj = { menuIds: menuIds, uId: this.permissionUser.id };
					console.log(obj);
					this.$api
						.request(
							this.$url.DealerAuthority.saveHideAuth,
							this.$method.post,
							obj
						)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: this.$t("roleAuth.upAuth"),
									type: "success",
								});
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				});
			} else {
				this.$message.warning("请至少选择一个权限");
			}
		},

		// reset() {
		// 	this.$refs.authTree.setCheckedKeys([]);
		// 	this.listPower = [];
		// 	this.checked = [];
		// },
	},
};
</script>

<style lang="scss">
.role-auth {
	padding-bottom: 30px;
	.roleFilter {
	}
	.power {
		color: var(--vtm-ink-2);
	}
	.list-power {
		margin-bottom: 10px;
	}
	.power-title {
		margin-bottom: 5px;
		.el-button--text {
			margin-left: 10px;
		}
	}
}
</style>
